module.exports = __webpack_public_path__ + "img/[惊讶].731671c4.svg";